module.exports = __webpack_public_path__ + "static/media/bilinear-lateral.165c3f2b.png";